<template>
  <div v-if="detailedPlayer && $store.getters.allSkillList">
    <div class="row columns">
      <div class="note text-left">choisissez et ajoutez une ou plusieurs compétences gratuites</div>
      <div class="note text-left alert">ATTENTION : ces compétences sont <strong>totalement</strong> gratuites,
        en terme de XP, ou de coût du joueur. </div>
      <br>
      <div class="large-2 columns">
        <div>Générale</div>
        <select :disabled="isDisabled && selectedG === null" v-model="selectedG">
            <option :value="null"> </option>
            <option v-for="skill of $store.getters.getSkillForSkillType('G')" v-bind:value="skill.id">{{skill.name}}</option>
        </select>
      </div>
      <div class="large-2 columns">
        <div>Force</div>
        <select :disabled="isDisabled && selectedF === null" v-model="selectedF">
          <option :value="null"> </option>
          <option v-for="skill of $store.getters.getSkillForSkillType('F')" v-bind:value="skill.id">{{skill.name}}</option>
        </select>
      </div>
      <div class="large-2 columns">
        <div>Agilité</div>
        <select :disabled="isDisabled && selectedA === null" v-model="selectedA">
          <option :value="null"> </option>
          <option v-for="skill of $store.getters.getSkillForSkillType('A')" v-bind:value="skill.id">{{skill.name}}</option>
        </select>
      </div>
      <div class="large-2 columns">
        <div>Passe</div>
        <select :disabled="isDisabled && selectedP === null" v-model="selectedP">
          <option :value="null"> </option>
          <option v-for="skill of $store.getters.getSkillForSkillType('P')" v-bind:value="skill.id">{{skill.name}}</option>
        </select>
      </div>
      <div class="large-2 columns">
        <div>Mutation</div>
        <select :disabled="isDisabled && selectedM === null" v-model="selectedM">
          <option :value="null"> </option>
          <option v-for="skill of $store.getters.getSkillForSkillType('M')" v-bind:value="skill.id">{{skill.name}}</option>
        </select>
      </div>
      <div class="large-2 columns">
        <div>Extraordinaire</div>
        <select :disabled="isDisabled && selectedE === null" v-model="selectedE">
          <option :value="null"> </option>
          <option v-for="skill of $store.getters.getSkillForSkillType('E')" v-bind:value="skill.id">{{skill.name}}</option>
        </select>
      </div>
    </div>
    <div class="row columns">
      <div class="large-12 columns">
      </div>
    </div>
    <button @click="addSelectedSkill()">
      <span class="large-btn-icon"><i class="fa fa-plus" aria-hidden="true"></i>&nbsp;Ajouter</span>
    </button>
    <button @click="addedSkills=[]" class="alert">
      <span class="large-btn-icon"><i class="fa fa-minus" aria-hidden="true"></i>&nbsp;Réinitialiser</span>
    </button>
    <br>
    <br>
    <div class="note text-left">liste de compétences actuelle</div>
    <table>
      <tbody class="large-font">
      <tr>
        <td width="50%">Compétences de Base</td>
        <td width="50%">
            <div class="skill" v-if="detailedPlayer.skills === null || detailedPlayer.skills.length === 0">Aucune</div>
            <span class="skill" v-else v-for="skill in detailedPlayer.skills">
                {{skill.name}},
            </span>
        </td>
      </tr>
      <tr>
        <td width="50%">Evolutions</td>
        <td width="50%">
          <div  class="skill" v-if="detailedPlayer.upgrades === null || detailedPlayer.upgrades.length === 0">Aucune</div>
          <span class="skill" v-else v-for="upg in detailedPlayer.upgrades">
                {{getUpgradeName(upg)}},
          </span>
        </td>
      </tr>
      <tr>
        <td width="50%">Customisations</td>
        <td width="50%">
          <div class="skill" v-if="addedSkills.length === 0">Aucune</div>
          <span class="skill" v-else v-for="skillId in addedSkills">
                {{getSkillName(skillId)}},
          </span>
          <div class="skill" v-else>Aucune</div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  export default {
    name: 'skill-customizer',
    props: {
      'detailedPlayer': {}
    },
    data () {
      return {
        addedSkills: [],
        selectedG: null,
        selectedF: null,
        selectedA: null,
        selectedP: null,
        selectedM: null,
        selectedE: null
      }
    },
    computed: {
      isDisabled: function () {
        if ((this.selectedG !== null && this.selectedG !== '') ||
          (this.selectedF !== null && this.selectedF !== '') ||
          (this.selectedA !== null && this.selectedA !== '') ||
          (this.selectedP !== null && this.selectedP !== '') ||
          (this.selectedM !== null && this.selectedM !== '') ||
          (this.selectedE !== null && this.selectedE !== '')) {
          return true
        }
        return false
      }
    },
    methods: {
      addSelectedSkill () {
        if (this.selectedG) {
          this.addedSkills.push(this.selectedG)
          this.selectedG = null
        }
        if (this.selectedF) {
          this.addedSkills.push(this.selectedF)
          this.selectedF = null
        }
        if (this.selectedA) {
          this.addedSkills.push(this.selectedA)
          this.selectedA = null
        }
        if (this.selectedP) {
          this.addedSkills.push(this.selectedP)
          this.selectedP = null
        }
        if (this.selectedM) {
          this.addedSkills.push(this.selectedM)
          this.selectedM = null
        }
        if (this.selectedE) {
          this.addedSkills.push(this.selectedE)
          this.selectedE = null
        }
      },
      getUpgradeName (upgrade) {
        if (upgrade.status === 0) {
          return ''
        }
        if (upgrade.value === 0 || upgrade.value === 1) {
          return upgrade.skill
        }
        if (upgrade.value === 2) {
          return ''
        }
        if (upgrade.value === 3) {
          return ''
        }
        if (upgrade.value === 4) {
          return ''
        }
        if (upgrade.value === 5) {
          return ''
        }
      },
      getSkillName (id) {
        return this.$store.getters.allSkillList.find(skill => { return skill.id === id }).name
      },
      isUsed () {
        return this.addedSkills.length !== 0
      }
    },
    mounted () {
      this.$store.dispatch('getAllSkillList')
    }
  }
</script>

<style scoped>
thead tr th {
    background-color: #ffffff;
    text-align: center;
    font-weight: 200;
    font-size:0.8rem;
}

tbody.large-font tr td{
    padding: 0.3rem 0.2rem;
    text-align: center;
    font-size:1.1rem;
}
tr td input, tr td select{
    padding: 0.5rem 0.5rem;
    text-align: center;
    font-size:0.7rem;
    margin: 0rem;
}

.large-font {
  font-size: 1.1rem
}
.button-column {
  text-align: right;
}
.note {
  font-size: 0.8rem;
  font-weight: 200;
}

.skill {
  font-weight: 300;
}
  .mt-3 {
    margin-top: 3rem
  }

  .mb-2 {
  margin-top: 2rem
}

.alert {
  color:#E7505A;
}

button.alert {
  color:#FFFFFF;
}
</style>



// WEBPACK FOOTER //
// skills-customizer.vue?7d7c3222